import { useCallback } from 'react';

/* eslint-disable @typescript-eslint/no-explicit-any */
const useRadio = props => {
  const {
    disabled,
    context,
    checked,
    setChecked,
    onChange,
    inputRef,
    onClick
  } = props;
  const handleContext = useCallback((value, event) => {
    if (context.group && context.onChangeValue) {
      context.onChangeValue(value, event);
    } else if (!('checked' in props) && !checked) {
      setChecked(true);
    }
  }, [context, setChecked, checked, props]);
  const handleOnChange = (value, event) => {
    if (disabled) {
      return;
    }
    handleContext(value, event);
    if (!checked && onChange) {
      onChange(true, event);
    }
  };
  const onLabelClick = useCallback(e => {
    e.preventDefault();
    inputRef.current && inputRef.current.click();
    onClick && onClick(e);
  }, [onClick, inputRef]);
  return {
    handleOnChange,
    onLabelClick
  };
};

export { useRadio };
